module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAlCAYAAAAuqZsAAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVRYCe3YMQ5AQBSE4Xmb1eIC7qCTOLiWykW0XIAEeZuoaKayxfzNNpu8rx6zpq8BtMioa5mnmFBWjCGWWcjOY/PHHAZHxap7ffqjfR3S1ZCF5iPB2ARjE4xNMDbB2ARjE4xNMDbB2ARjE4xNMDbB2ARjE4xNMLa0KPq8+Cx5WQTgBghzELy9TXQYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-blue-2.png
// module id = 263
// module chunks = 0